import { Component, computed, input } from '@angular/core';

import { CmsDestination } from '@fcom/core-api';

@Component({
  selector: 'cms-ond-marketing-offers',
  template: ` <fin-ond-marketing-offers [destinationLocationCode]="destinationLocationCode()" /> `,
  standalone: false,
})
export class CmsOndMarketingOffersComponent {
  readonly content = input.required<CmsDestination>();

  readonly destinationLocationCode = computed(() => {
    return this.content()?.locationCode;
  });
}
